import { Component, OnInit } from '@angular/core';
import {FabricRepository} from '../../../repositories/fabric.repository';
import MaterialInterface from '../../../models/material.interface';
import FabricInterface from '../../../models/fabric.interface';

@Component({
  selector: 'app-fabrics',
  templateUrl: './fabrics.page.html',
  styleUrls: ['./fabrics.page.css'],
})
export class FabricsPage implements OnInit {

  public materials: MaterialInterface[];

  getFabricsInMaterialVariations(material: MaterialInterface) {
    const fabricsInMaterial = this.fabricRepository.all()
        .filter(fabric => fabric.material === material.id);

    return material.variations.map(variation => {
      return {
        variation: variation.name,
        fabrics: fabricsInMaterial
            .filter(fabric => fabric.variation === variation.id)
            .sort((a, b) => a.position - b.position)
      };
    });
  }

  getFabricsInMaterial(material: MaterialInterface) {
    return this.fabricRepository.all()
        .filter(fabric => fabric.material === material.id)
        .sort((a, b) => a.position - b.position);
  }

  constructor(private fabricRepository: FabricRepository) {
    this.materials = fabricRepository.materials();
    console.log(this.materials);
  }

  ngOnInit() {
  }

}
